import React from 'react'
import { BaseView, BaseText } from '@/components/base'
import { Avatar } from '@/components/Avatar'
import { CurrencyCatalogsDTO } from '@/domain/currencies'
import { useTheme } from '@/hooks/useTheme'

interface DisplayCurrencyItemProps {
  currency: CurrencyCatalogsDTO
  isSelected?: boolean
  onPress: (currency: CurrencyCatalogsDTO) => void
}

export const DisplayCurrencyItem: React.FC<DisplayCurrencyItemProps> = ({
  currency,
  onPress,
}) => {
  const handlePress = () => {
    onPress(currency)
  }

  return (
    <BaseView
      row
      align="center"
      px={16}
      py={10}
      style={{
        cursor: 'pointer',
        backgroundColor: '#242427',
        borderRadius: '24px',
      }}
      onClick={handlePress}
    >
      {/* Currency Avatar */}
      <BaseView style={{ marginRight: '16px' }}>
        <Avatar
          fullSize={false}
          uri={currency.img_url}
          size={48}
          isCurrency={true}
          fallbackText={currency.isin}
        />
      </BaseView>

      {/* Currency Info */}
      <BaseView flex={1}>
        <BaseText
          fontSize={16}
          fontFamily="semibold"
          color="label.default"
          style={{ marginBottom: '4px' }}
        >
          {currency.name}
        </BaseText>
        <BaseText fontSize={14} fontFamily="regular" color="label.description">
          {currency.isin}
        </BaseText>
      </BaseView>

      {/* Chevron Icon - как в React Native */}
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 18l6-6-6-6"
          stroke="#A0A2A4"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </BaseView>
  )
}
